import fourC from '../../assets/machines/4c.webp';
import fiveC from '../../assets/machines/5c.webp';
import fiveX from '../../assets/machines/5x.webp';
import blizzard from '../../assets/machines/blizzard.webp';
import generic from '../../assets/machines/generic.svg';
import helius from '../../assets/machines/helius.webp';

/**
 * Machine renders keyed by normalised family name.
 *
 * EDMS has no image for a machine, so these ship as static assets keyed off
 * `family` - the only field that identifies the machine type rather than the
 * individual unit. Families without a usable product render (Spectrim, 4A, MLS,
 * Titan) fall through to a generic silhouette, as does any value we have not
 * seen before: `family` is free text in EDMS with no enum behind it.
 *
 * To add a family: drop the tile in `assets/machines` and add one entry here.
 */
const FAMILY_IMAGES: Record<string, string> = {
  '4c': fourC,
  '5c': fiveC,
  '5x': fiveX,
  blizzard,
  helius,
};

/**
 * EDMS is inconsistent about the brand prefix - both "TOMRA 5C" and a bare "4C"
 * occur in the same dataset - so normalise before matching.
 */
function normalizeFamily(family: string): string {
  return family
    .trim()
    .toLowerCase()
    .replace(/^tomra\s+/, '')
    .replace(/\s+/g, ' ');
}

/**
 * Resolve a machine family to its tile image, falling back to the generic
 * silhouette. Always returns a usable image source.
 */
export function getMachineFamilyImage(family?: string | null): string {
  if (!family) return generic;
  return FAMILY_IMAGES[normalizeFamily(family)] ?? generic;
}
